/* unplugin-vue-components disabled */import script from "./HotelPriceOperate.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelPriceOperate.vue?vue&type=script&setup=true&lang=js"

import "./HotelPriceOperate.vue?vue&type=style&index=0&id=478a4db0&lang=scss"

const __exports__ = script;

export default __exports__